// extracted by mini-css-extract-plugin
export default {"container":"Dynamic_container__BhPlN"};